import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewMisService } from '../view-mis/view-mis.service';
import { environment as ENV } from '../../../environments/environment';
import { AddCoapplicantComponent } from '../add-coapplicant/add-coapplicant.component';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { DialogData, OpenAdminDialogYesOrNo } from '../admin-yes-or-no/admin-yes-or-no.component';
import * as constants from '../../constant';
import { debounceTime, distinctUntilChanged, mergeMap } from 'rxjs/operators';
import { state } from '@angular/animations';



@Component({
  selector: 'wl-view-utilities',
  templateUrl: './view-utilities.component.html',
  styleUrls: ['./view-utilities.component.scss'],
  providers: [ViewMisService, AddCustomerService, AdminService],
})
export class ViewUtilitiesComponent implements OnInit {
  allUsers: Observable<any>;
  allUsersDetails: any = [];
  transferDetails: any = [];
  isDataPending: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: any;
  role: string;
  limit: number = 10;
  offset: number = 0;
  
  userName: string;
  display: boolean;
  typeText: string;
  addUserForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  makerOnly: boolean = true;
  pageId: any = 1;
  @ViewChild('date1') firstDate: ElementRef;
  selectedDate: string;
  showSelectedDate: boolean;
  currentDate: any;
  transferForm: UntypedFormGroup;
  resetForm: UntypedFormGroup;
  codePlaceholder: string;
  branchPlaceholder: string;
  coSelected: boolean;
  zonalSelected: boolean;
  roSelected: boolean;
  branchSelected: boolean;
  options: any = [];
  popup: boolean = false;
  viewDetails: any;
  responsemessage: any;
  time: any;
  popup1: boolean = false;
  dist: any;
  distnew: any;
  showAddUserTab: boolean;
  showTransferUserTab: boolean;
  showAddUserReqTab: boolean;
  showTransferUserReqTab: boolean;
  userRoleId: any;
  superAdminOrMaker: boolean = false;
  checkerUser: boolean = false;
  profileChoice: any;
  coOfficeCode: boolean = false;
  superAdminUser: boolean = false;
  centralOfficeUser: boolean = false;
  makerRoleId: string = '11';
  checkerRoleId: string = '12';
  subheading1: string;
  subheading2: string;
  loading: boolean;
  pfNumber: string = '';
  disableUserDetails: any;
  transferUserDetails: any;
  showTransferUserDetail: boolean;
  isStaffIdReadOnly: boolean;
  pfNoReset: any;
  showResetUserDetail: boolean;
  viewOrHideDetailsButtonTextReset: any = constants.VIEW_DETAILS;
  isStaffIdReadOnlyReset: boolean;
  resetUserDetails: any;
  typeType: string = "password";
  showPassword: any;
  typeTypeConfirm: string = "password";
  showPasswordConfirm: any;
  solIdType: any;
  showSolIdDetail: boolean;
  viewDetailsSolIdText: string = constants.VIEW_DETAILS;
  isSolIdReadOnly: boolean;
  viewOrHideDetailsButtonText: string = constants.VIEW_DETAILS;
  disableForm: UntypedFormGroup;

  constructor(
    private customer: ViewMisService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private adminAuth: AdminAuthService,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    // public modalService: NgbModal
    private modalService: BsModalService
  ) {
    this.addUserForm = this.fb.group({
      access_level: ['', Validators.required],
      branchName: [''],
      //profile: ['',],
      code: ['', Validators.required],
      staffName: ['', Validators.compose([Validators.required])],
      staffId: ['', Validators.required],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      mobileNo: [
        '',
        Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')]),
      ],
    });

    this.transferForm = this.fb.group({
      staffId: ['', Validators.required],
      zrbcode: ['', Validators.required],
      // type: ['', Validators.required],
      //disabled fields for view details below
      state: ['',],
      zone: ['',],
      ro: ['',],
      branch: ['',],
      name: ['',],
      mobileNo: ['',],
      email: ['',],

      //solId details
      state_name: [''],
      zone_name: [''],
      zone_code: [''],
      ro_name: [''],
      ro_code: [''],
      branch_name: [''],
      branch_code: [''],
      type: ['']
    });

    this.resetForm = this.fb.group({
      staffId: ['', Validators.required],
      password: ['', [Validators.required,Validators.pattern(`^(?=.*[!@#$%^&*()_+\\-={}\\[\\]|;:'\",.<>/?])(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{10,}$`
      )]],
      confirmPassword: ['', Validators.required],

      //disabled fields for view details below~
      state: ['',],
      zone: ['',],
      ro: ['',],
      branch: ['',],
      name: ['',],
      mobileNo: ['',],
      email: ['',],
    })

    this.disableForm = this.fb.group({
      pfNumber : ['',],
      state : ['',],
      zone : ['',],
      ro : ['',],
      branch : ['',],
      staffName : ['',],
      mobileNo : ['',],
      email : ['',],

    })


    this.search.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      mergeMap((search) => this.customer.getUsers(search, this.roleId, 0, 10))
  ).subscribe(
      (res) => {
          if (res.result && res.result.resultData && res.result.resultData.length == 0) {
              this.noUserFound = 'No User found for query: ' + this.search.value;
          } else {
              this.noUserFound = null;
          }
          this.page = 1;
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
      },
      (err) => {
          throw err;
      }
  );
  }

  ngOnInit() {
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();
    this.branchPlaceholder = 'Enter Central Office/Zonal/RO/Branch Sol Id';
    this.getZoneCode();
    this.getUserRequestDetails();
    this.transferUserRequestDetails();
    this.getAccessLevel();
    //this.getUserRole();
    this.codePlaceholder = 'Enter Central Office/Zonal/RO/Branch Sol Id';
    this.currentDate = moment().format('YYYY-MM');
    // const token = sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');

    this.adminservice.getUserRoleList().subscribe((response) => {
      this.userRoleId = sessionStorage.getItem('getroleId');
      this.roleId = sessionStorage.getItem('getroleId');

      if (this.userRoleId === response.result.SuperAdmin) {
        this.superAdminOrMaker = true;
        this.superAdminUser = true;
      } else if (
        this.userRoleId == response.result.Maker ||
        this.userRoleId == this.makerRoleId ||
        this.userRoleId == '7'
      ) {
        this.superAdminOrMaker = true;
      } else if (
        this.userRoleId == response.result.Checker ||
        this.userRoleId == this.checkerRoleId ||
        this.userRoleId == '8'
      ) {
        this.checkerUser = true;
      } else if (this.userRoleId === response.result.CentralOffice) {
        this.superAdminOrMaker = true;
        this.centralOfficeUser = true;
      }
    },
      (err) => {
        this.roleId = sessionStorage.getItem('getroleId');

        if (this.userRoleId == 0) {
          this.superAdminOrMaker = true;
          this.superAdminUser = true;
        } else if (
          this.userRoleId == '7'
        ) {
          this.superAdminOrMaker = true;
        } else if (
          this.userRoleId == '8'
        ) {
          this.checkerUser = true;
        } else if (this.userRoleId == '1') {
          this.superAdminOrMaker = true;
          this.centralOfficeUser = true;
        }
      });

    this.getAllUsers('', this.roleId, 0, 10);

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  ngAfterViewInit() {
    this.resetForm.reset()
  }

  togglePassword() {
    this.typeType == "password"
      ? (this.typeType = "text")
      : (this.typeType = "password");
    let password = this.showPassword;
    this.showPassword = !password;
  }
  togglePasswordConfirm() {
    this.typeTypeConfirm == "password"
      ? (this.typeTypeConfirm = "text")
      : (this.typeTypeConfirm = "password");
    let password = this.showPasswordConfirm;
    this.showPasswordConfirm = !password;
  }

  getAccessLevel() {
    this.adminservice.getAccessLevelList().subscribe((response) => {
      if (response && response.success && response.result) {
        this.distnew = response.result;
      }
    });
  }

  getZoneCode() {
    const selection = this.adminservice.zoneSelection;

    const mapObject = (obj) => {
      let newObj = {};
      if (selection === 'Zone') {
        newObj['id'] = obj.zone_name;
        newObj['name'] = obj.zone_code;
        newObj['combinedName'] = obj.zone_name + ' - ' + obj.zone_code
      } else if (selection === 'RO') {
        newObj['id'] = obj.ro_name;
        newObj['name'] = obj.ro_code;
        newObj['combinedName'] = obj.ro_name + ' - ' + obj.ro_code
      } else if (selection === 'Branch') {
        newObj['id'] = obj.branch_name;
        newObj['name'] = obj.branch_code;
        newObj['combinedName'] = obj.branch_name + ' - ' + obj.branch_code
      }
      return newObj;
    };

    const handleResponse = (response) => {
      console.log('--------response: ' + JSON.stringify(response));
      if (response && response.success && response.result) {
        this.dist = response.result;
        this.options = this.dist.map(mapObject);
      }
    };

    if (this.roleId == '1' && selection !== 'CO') {
      console.log('who am i------------>')
      this.adminservice.getDropDownValues(true, selection.toLowerCase()).subscribe((response) => {
        if (response && response.message === 'success' && !response.error) {
          this.dist = response.result;
          this.options = this.dist.map(mapObject);
        }
      });
    } else {
      this.adminservice.getOfficeCode(selection).subscribe(handleResponse);
    }
  }

  getUserRequestDetails() {
    this.loading = true;
    this.adminservice.getUserRequest().subscribe((response) => {
      this.loading = false;
      this.allUsersDetails = response.result;
    });
  }

  transferUserRequestDetails() {
    this.loading = true;
    this.adminservice.transferUserRequestList().subscribe((response) => {
      this.loading = false;
      this.transferDetails = response.result;
    });
  }

  zoneSelected(event) {
    console.log('event------->', event)
    this.addUserForm.get('branchName').setValue(event.id)
    this.addUserForm.get('code').setValue(event.name);
  }

  transferSubmit(formDirective: FormGroupDirective) {
    let value = { ...this.transferForm.value };
    let locGetUserId = sessionStorage.getItem('getuserId');
    let locWlAdminId = sessionStorage.getItem('wl-admin-id');
    value = {
      ...value,
      addedBy: locWlAdminId,
      user_id: locGetUserId, //maker id  or super admin id
      type:this.solIdType
    };
    this.adminservice.transferRequest(value).subscribe(
      (response) => {
        let message = '';
        if (
          response &&
          response.message &&
          response.success &&
          (this.userRoleId == 7 || this.userRoleId == this.makerRoleId || this.userRoleId == '7')
        ) {
          message = 'The user transfer request has been forwarded successfully';
        } else if (
          response &&
          response.message &&
          response.success &&
          (this.userRoleId == 0 || this.userRoleId == 1)
        ) {
          message = 'The user has been transferred successfully!';
        } else if (response && response.message == 'Invalid RO Code') {
          message = 'Invalid code entry. Please enter correct code.';
        } else if (response && response.message == 'Invalid Zone Code') {
          message = 'Invalid code entry. Please enter correct code.';
        } else if (response && response.message == 'Invalid Branch Code') {
          message = 'Invalid code entry. Please enter correct code.';
        } else if (response && response.message == 'Something went wrong') {
          message = 'Something went wrong, please try after some time.';
        } else if (response && response.message == 'Unauthorized access Invalid staff ID') {
          message = 'Unauthorized access Invalid staff ID.';
        } else if (response && response.error == 'Unauthorized access Invalid staff ID') {
          message = 'Unauthorized access Invalid staff ID.';
        }
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          disableClose: true,
          data: {
            //content1: "The user transfer request has been forwarded successfully",
            content1: message,
            button1Text: 'OK',
          },
        });

        dialogRef.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            if (response.success == true) {
              this.transferForm.reset();
              formDirective.resetForm();
            }
          } else {
          }
        });
      },
      (error) => {
        this.snackbar.open('Unauthorized error, Enter valid information', 'OK', { duration: 3000 });
      }
    );
  }

  commonCode() {
    if (this.superAdminUser || this.centralOfficeUser) {
      console.log('our testing last');
      this.addUserForm.addControl('profile', this.fb.control('', Validators.required));
      this.addUserForm.get('profile').reset();
    } else {
      this.addUserForm.removeControl('profile');
    }

    this.addUserForm.get('branchName').setValue('');
  }

  accessSelected(value) {
    this.addUserForm.get('code').reset();
    this.adminservice.zoneSelection = value;
    this.getZoneCode();
    if (value == 'CO') {
      this.codePlaceholder = 'Enter Central Office Name';
      this.coSelected = true;
      this.zonalSelected = false;
      this.roSelected = false;
      this.branchSelected = false;
      this.branchPlaceholder = 'Central Office Sol Id';
      // this.addUserForm.get("branchName").setValue("");
      this.coOfficeCode = true;
      this.commonCode();
      // this.addUserForm.get('profile').reset();
    } else if (value == 'Zone') {
      // this.addUserForm.removeControl('profile');
      this.codePlaceholder = 'Enter Zonal Office Name';
      this.branchPlaceholder = 'Zonal Office Sol Id';
      this.coSelected = false;
      this.zonalSelected = true;
      this.roSelected = false;
      this.branchSelected = false;
      this.coOfficeCode = false;
      this.commonCode();
    } else if (value == 'RO') {
      this.codePlaceholder = 'Enter Regional Office Name';
      this.branchPlaceholder = 'Regional Office Sol Id';
      this.coSelected = false;
      this.zonalSelected = false;
      this.roSelected = true;
      this.branchSelected = false;
      this.coOfficeCode = false;
      this.commonCode();
    } else if (value == 'Branch') {
      this.codePlaceholder = 'Enter Branch Sol Id';
      this.branchPlaceholder = 'Branch Office Sol Id';
      this.coSelected = false;
      this.zonalSelected = false;
      this.roSelected = false;
      this.branchSelected = true;
      this.coOfficeCode = false;
      this.commonCode();
    }
  }

  showDetails(user) {
    this.popup = true;

    let approveOrReject = 'approve';
    let codeText = '';
    if (user && user.request && user.request.type == 'Zone') {
      codeText = 'Zone Sol Id';
    } else if (user && user.request && user.request.type == 'RO') {
      codeText = 'RO Sol Id';
    } else if (user && user.request && user.request.type == 'Branch') {
      codeText = 'Branch Sol Id';
    } else if (user && user.request && user.request.type == 'CO') {
      codeText = 'CO Sol Id';
    }

    const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      data: {
        content2: `User Details`,
        content3: `Staff ID : ${user.request.staffId ? user.request.staffId : ''}`,
        content4: `Staff Name : ${user.request.staffName ? user.request.staffName : ''}`,
        content5: `Mobile No : ${user.request.mobileNo ? user.request.mobileNo : ''}`,
        content6: `Email : ${user.request.email ? user.request.email : ''}`,
        content7: `${codeText} : ${user.request.zrbcode ? user.request.zrbcode : ''}`,
        /* content7: `Staff ID : ${user.request.staffId?user.request.staffId:""}`, 
        content8: `Staff ID : ${user.request.staffId?user.request.staffId:""}`, 
        content9: `Staff ID : ${user.request.staffId?user.request.staffId:""}`, 
        content10: `Staff ID : ${user.request.staffId?user.request.staffId:""}`,  */
        button1Text: 'Create User',
        button2Text: 'Reject Request',
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'yes') {
        const dialogRefConfirm = this.dialog.open(OpenAdminDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          data: {
            content1: constants.USER_PROFILE_WILL_BE_CREATED_CONFIRM,
            button1Text: 'Yes',
            button2Text: 'No',
          },
        });
        dialogRefConfirm.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            let staffId = user.request.staffId;
            let cId = user.response.appId || user.response.cId;
            let user_request_id = user.ur_id;
            let user_id = sessionStorage.getItem('getuserId');
            this.approveOrReject(
              'approved',
              staffId,
              this.userRoleId,
              cId,
              user_id,
              user_request_id
            );
          } else {
          }
        });
      } else if (res == 'no') {
        const dialogRefConfirm = this.dialog.open(OpenAdminDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          data: {
            content1: constants.REJECT_CREATION_REQST,
            button1Text: 'Yes',
            button2Text: 'No',
          },
        });
        dialogRefConfirm.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            let staffId = user.request.staffId;
            let cId = user.response.appId || user.response.cId;
            let user_request_id = user.ur_id;
            let user_id = sessionStorage.getItem('getuserId');
            this.approveOrReject(
              'rejected',
              staffId,
              this.userRoleId,
              cId,
              user_id,
              user_request_id
            );
          }
        });
      }
    });
  }

  showTransferUserDetails(user) {
    let codeText = '';
    let approveOrReject = 'approve';
    const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      data: {
        content2: constants.TRANSFER_REQ_DETAILS,
        content3: `Staff ID : ${user.staffId ? user.staffId : ''}`,
        content4: `${user.TransferToData.type} Sol Id : ${user.TransferToData.zrbcode ? user.TransferToData.zrbcode : ''
          }`,
        button1Text: 'Transfer User',
        button2Text: 'Reject Request',
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'yes') {
        const dialogRefConfirm = this.dialog.open(OpenAdminDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          data: {
            content11: `The Staff ID:${user.staffId} will be transferred to ${user.TransferToData.type} Sol Id:${user.TransferToData.zrbcode}. Do you confirm?`,
            button1Text: 'Yes',
            button2Text: 'No',
          },
        });
        dialogRefConfirm.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            let staffId = user.staffId;
            let zrbcode = user.TransferToData.zrbcode;
            let user_id = sessionStorage.getItem('getuserId');
            let transfer_request_id = user.tr_id;
            let type = user.TransferToData.type;
            this.approveOrRejectUserTransfer(
              'approved',
              staffId,
              zrbcode,
              user_id,
              transfer_request_id,
              type
            );
          } else {
          }
        });
      } else if (res == 'no') {
        const dialogRefConfirm = this.dialog.open(OpenAdminDialogYesOrNo, {
          width: 'auto',
          height: 'auto',
          data: {
            content1: constants.REJECT_CREATION_REQST,
            button1Text: 'Yes',
            button2Text: 'No',
          },
        });
        dialogRefConfirm.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            let staffId = user.staffId;
            let zrbcode = user.TransferToData.zrbcode;
            let user_id = sessionStorage.getItem('getuserId');
            let transfer_request_id = user.tr_id;
            let type = user.TransferToData.type;
            this.approveOrRejectUserTransfer(
              'rejected',
              staffId,
              zrbcode,
              user_id,
              transfer_request_id,
              type
            );
          } else {
          }
        });
      }
    });
  }

  close() {
    this.popup = false;
  }

  profileSelected(value) {
    this.profileChoice = value;

    if (
      this.profileChoice == 'centralOffice' ||
      this.profileChoice == 'maker' ||
      this.profileChoice == 'checker'
    ) {
      this.addUserForm.get('code').setValue('57365');
      this.addUserForm.get('branchName').setValue('Central Office');
    }
  }

  approveOrReject(
    approvalStatus: string,
    staffId: string,
    userRole: any,
    cId,
    user_id: string,
    user_request_id
  ) {
    //user_id is who is approving
    // user_request_id is who is approving
    //let user_id_test = '7eae2e02-b45b-41fc-a369-cd5633eb10cd'
    var data = { approvalStatus, staffId, userRole, cId, user_id, user_request_id };
    this.adminservice.approveOrReject(data).subscribe(
      (resp) => {
        this.getUserRequestDetails();
        if (
          resp &&
          resp.message &&
          resp.success &&
          resp.message == 'User Creation Request Approved Successfully'
        ) {
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto',
            height: 'auto',
            data: {
              content1: constants.PROFILE_CREATED,
              button1Text: 'OK',
            },
          });
        }
        if (
          resp &&
          resp.message &&
          resp.success &&
          resp.message == 'User Creation Request Rejected Successfully'
        ) {
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto',
            height: 'auto',
            data: {
              content1: constants.USER_CREATION_REJECT,
              button1Text: 'OK',
            },
          });
        }
        if (resp.message == 'Invalid Request') {
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto',
            height: 'auto',
            data: {
              content1: constants.MESSAGE_INVALID_REQUEST,
              button1Text: 'OK',
            },
          });
        }
      },

      (error) => {
        this.snackbar.open(constants.SOMETHING_WENT_WRONG, 'OK', { duration: 3000 });
      }
    );
  }

  approveOrRejectUserTransfer(
    approvalStatus: string,
    staffId: string,
    zrbcode,
    user_id: string,
    transfer_request_id: any,
    type: any
  ) {
    //user_id is who is approving
    // user_request_id is who is approving
    // let user_id_test = '7eae2e02-b45b-41fc-a369-cd5633eb10cd';
    // let type = "Zone"
    let addedBy = sessionStorage.getItem('wl-admin-id');
    var data = { approvalStatus, staffId, user_id, zrbcode, type, transfer_request_id, addedBy };
    this.adminservice.transferAcceptOrReject(data).subscribe(
      (resp) => {
        this.transferUserRequestDetails();
        if (
          resp &&
          resp.message &&
          resp.success &&
          resp.message == 'Transfer was Approved Successfully'
        ) {
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto',
            height: 'auto',
            data: {
              content1: constants.USER_PROFILE_TRANSFERED,
              button1Text: 'OK',
            },
          });
        }
        if (
          resp &&
          resp.message &&
          resp.success &&
          resp.message == 'Transfer was Rejected Successfully'
        ) {
          //this.transferUserRequestDetails()
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto',
            height: 'auto',
            data: {
              content1: constants.TRANSFER_REQ_REJECTED,
              button1Text: 'OK',
            },
          });
        }
      },
      (error) => {
        this.snackbar.open(constants.SOMETHING_WENT_WRONG, 'OK', { duration: 3000 });
      }
    );
  }

  setTimeout() {
    this.time = setTimeout(() => {
      this.popup1 = false;
    }, 4000);
  }

  addUser(formDirective: FormGroupDirective) {
    let value = { ...this.addUserForm.value };

    if (value.access_level == 'CO' && this.profileChoice == 'centralOffice') {
      value = { ...value, zrbcode: value.code, roleId: '1' };
    }
    if (value.access_level == 'CO' && this.profileChoice == 'checker') {
      value = { ...value, zrbcode: value.code, roleId: this.checkerRoleId };
    } else if (value.access_level == 'CO' && this.profileChoice == 'maker') {
      value = { ...value, zrbcode: value.code, roleId: this.makerRoleId };
    }
    if (this.roleId == '0' || this.roleId == '1') {
      console.log('super admin check');

      if (value.access_level == 'Zone' && this.profileChoice == 'zoneAdmin') {
        value = { ...value, zrbcode: value.code, roleId: '2' };
      }

      if (value.access_level == 'RO' && this.profileChoice == 'roAdmin') {
        value = { ...value, zrbcode: value.code, roleId: '3' };
      }
      if (value.access_level == 'Branch' && this.profileChoice == 'branchAdmin') {
        value = { ...value, zrbcode: value.code, roleId: '4' };
      }
      if (value.access_level == 'Zone' && this.profileChoice == 'zoneuser') {
        value = { ...value, zrbcode: value.code, roleId: '21' };
      }
      if (value.access_level == 'RO' && this.profileChoice == 'roUser') {
        value = { ...value, zrbcode: value.code, roleId: '31' };
      }
      // if(value.access_level == "Branch" && this.profileChoice  == "branchuser" ){
      //   value = {...value, zrbcode: value.code, roleId: '41'}
      // }
    }
    if (this.roleId == '7' || this.roleId == '11') {
      console.log('check our condition');
      console.log('roleid', this.roleId);
      if (value.access_level == 'Zone') {
        value = { ...value, zrbcode: value.code, roleId: '21' };
      }
      if (value.access_level == 'RO') {
        value = { ...value, zrbcode: value.code, roleId: '31' };
      }
      if (value.access_level == 'Branch') {
        value = { ...value, zrbcode: value.code, roleId: '4' };
      }
    }

    let locWlAdminId = sessionStorage.getItem('wl-admin-id');
    let adminServZoneSelect = this.adminservice.zoneSelection;
    let locGetUserId = sessionStorage.getItem('getuserId');
    value = {
      ...value,
      addedBy: locWlAdminId,
      type: adminServZoneSelect,
      user_id: locGetUserId,
    };

    // if (this.coSelected == true) {

    // }
    // else {

    // }
    value = { ...value, profile: this.profileChoice };

    this.adminservice.createUser(value).subscribe(
      (resp) => {
        let message = '';
        if (
          resp &&
          resp.message &&
          resp.success &&
          (resp.message == 'User Creation Request placed Successfully' ||
            resp.message == 'User Created Successfully')
        ) {
          if (this.roleId == 0 || this.roleId == 1) {
            message = 'The user profile has been created successfully!';
          } else if (this.roleId == 1) {
          } else if (this.roleId == 2) {
          } else if (this.roleId == 3) {
          } else if (this.roleId == 4) {
          } else if (this.roleId == 8 || this.roleId == this.checkerRoleId) {
            // message = "The user creation request has been forwarded successfully."
          } else if (this.roleId == 6) {
          } else if (this.roleId == 7 || this.roleId == this.makerRoleId) {
            message = 'The user creation request has been forwarded successfully.';
          }
        } else if (resp.message == 'Email-Id already exists') {
          message = 'Email ID already exists.';
        } else if (resp.message == 'StaffId length should be minimum of six characters') {
          message = 'StaffId length should be minimum of six characters';
        } else if (resp.message == 'mobileNo already exists') {
          message = 'Mobile number already exists.';
        } else if (resp.message == 'Code not found') {
          message = 'Code not found, Please select correct code.';
        } else if (resp.message == 'Staff Id already exists') {
          message = 'Staff ID already exists.';
        } else {
          message = constants.SOMETHING_WENT_WRONG;
        }
        const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
          disableClose: true,
          width: 'auto',
          height: 'auto',
          data: {
            content1: message,
            button1Text: 'OK',
          },
        });
        dialogRef.afterClosed().subscribe((res) => {
          if (res == 'yes') {
            if (
              resp.message == 'User Creation Request placed Successfully' ||
              resp.message == 'User Created Successfully'
            ) {
              this.addUserForm.reset();
              formDirective.resetForm();
            }
          } else {
          }
        });
      },
      (error) => {
        this.snackbar.open(constants.SOMETHING_WENT_WRONG, 'OK', { duration: 3000 });
      }
    );
  }

  submitDates() {
    this.showSelectedDate = true;
    let selected = this.firstDate.nativeElement.value;
    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var another = months[+selected.split('-')[1] - 1];
    this.selectedDate = another + ', ' + selected.split('-')[0];
    let filterDate = this.firstDate.nativeElement.value + '-01';
    sessionStorage.setItem('filterDateViewOnline', filterDate);
    let date = new Date(filterDate);
    let dateInMs = date.getTime();
    this.customer.getUsersFilterDate('', this.roleId, 0, 10, dateInMs).subscribe((res) => {
      if (res && res.result && res.result.resultData) {
        this.allUsers = res.result.resultData ? res.result.resultData : '';
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
      }
    });
  }

  getAllUsers(input, roleId, offset, limit) {
    this.isDataPending = true;
    // this.page = pageId;

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.isDataPending = false;
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        // }
        // this.custId = res.result.custId;
      },
      (err) => {
        this.isDataPending = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
    // this.customer.getUsers(this.search.value, pageId).subscribe(res => {
    //   this.isDataPending = false;
    //   this.allUsers = res.result;
    //   this.totalCount = res.count;
    //   this.totalPage = Math.ceil(this.totalCount / 10);
    //   this.custId = res.result.custId;
    // }, err => {
    //   this.isDataPending = false;
    //   this.allUsers = Observable[''];
    //   throw err
    // })
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    this.pageId = pageId;
    this.isDataPending = true;

    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    this.customer.getUsers(input, roleId, offset, limit).subscribe(
      (res) => {
        this.isDataPending = false;
        this.allUsers = res.result.resultData ? res.result.resultData : '';
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        // this.custId = res.result.custId;
      },
      (err) => {
        this.isDataPending = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );

  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }

  getLogReport() {
    const data = {
      custId: this.adminId,
      type: 1,
    };
  }

  retailCheck(isRetail) {
    this.snackbar.open('Co Applicant details not found', 'OK', { duration: 2000 });
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }
  openDialog(customerId, type, isRetail) {
    const data = {
      custId: customerId,
      type: type,
      isRetail: isRetail,
    };

    this.bsModalRef = this.modalService.show(AddCoapplicantComponent, {
      animated: false,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: data,
    });
    this.bsModalRef.content.onClose.subscribe((result) => { });
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }

  openCust(
    applicantId,
    custName,
    custId,
    isApplicant,
    isValidated,
    custMail,
    isCan,
    paymentStatus,
    paymentId,
    isRetail
  ) {
    sessionStorage.setItem('applicantId', applicantId);
    sessionStorage.setItem('wl-applicant-id', applicantId);

    switch (ENV.creditScoreSetting.credMenu) {
      case 'ubi':
        if (!isValidated && isApplicant && isCan) {
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            if (res && res.custId && res.custId.length > 0) {
              window.open(ENV.urlSetting.url + 'laas/applications/loan-renewal-form');
            }
            this.getAllUsers('', this.roleId, 0, 10);
          });
        } else if (!isValidated && isApplicant && !isCan && !paymentStatus) {
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            if (res && res.custId && res.custId.length > 0) {
              window.open(ENV.urlSetting.url + 'laas/applications/loan-renewal-form');
            }
            this.getAllUsers('', this.roleId, 0, 10);
          });
        } else {
          this.auth.userLogin('test@123', custId).subscribe((res) => {
            if (res && res.custId && res.custId.length > 0) {
              window.open(ENV.urlSetting.url + 'laas/applications/loan-renewal-form');
            }
          });
        }

        break;

      default:
        window.open(ENV.urlSetting.url + 'login/' + custId);
        break;
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateViewOnline');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  fetchUserDetails(pfNo, type) {
    if (type == "transfer") {
      if (this.viewOrHideDetailsButtonText == constants.HIDE_DETAILS) {
        this.showTransferUserDetail = false;
        this.viewOrHideDetailsButtonText = constants.VIEW_DETAILS;
        this.isStaffIdReadOnly = false;
        return
      }
    } else if (type == "reset") {
      if (this.viewOrHideDetailsButtonTextReset == constants.HIDE_DETAILS) {
        this.showResetUserDetail = false;
        this.viewOrHideDetailsButtonTextReset = constants.VIEW_DETAILS;
        this.isStaffIdReadOnlyReset = false;
        return
      }
    }
    this.adminservice.getUserDetails(this.adminId, pfNo, this.roleId).subscribe(
      (response) => {
        if (response.message !== 'success') {
          this.snackbar.open(response.error, 'OK', {
            duration: 4000,
          });
        } else if (response && response.result && response.result.id === this.adminId) {
          this.snackbar.open(`Cannot ${type} Logged In User`, 'OK', {
            duration: 4000,
          });
        } else {
          type == "disable" ?
            this.disableUserDetails = response.result :
            type == "transfer" ? this.patchTransfterValues(response.result, type) :
              type == "reset" ? this.patchTransfterValues(response.result, type) : "";
        }
      },
      (error) => {
        this.snackbar.open(error.message, 'OK', {
          duration: 4000,
        });
      }
    );
  }
  patchTransfterValues(data, type) {
    if (type == "transfer") {
      this.transferUserDetails = data;
      this.showTransferUserDetail = true;
      this.viewOrHideDetailsButtonText = constants.HIDE_DETAILS;
      this.isStaffIdReadOnly = true;
      this.transferForm.patchValue(
        {
          state: data.state ? data.state : "-",
          zone: data.zone_name ? data.zone_name : "-",
          ro: data.ro_name ? data.ro_name : "-",
          branch: data.branch_name ? data.branch_name : "-",
          name: data.staffName ? data.staffName : "-",
          mobileNo: data.mobileNo ? data.mobileNo : "-",
          email: data.email ? data.email : "-"
        }
      )
    } else if (type == "reset") {
      this.resetUserDetails = data;
      this.showResetUserDetail = true;
      this.viewOrHideDetailsButtonTextReset = constants.HIDE_DETAILS;
      this.isStaffIdReadOnlyReset = true;
      this.resetForm.patchValue(
        {
          state: data.state ? data.state : "-",
          zone: data.zone_name ? data.zone_name : "-",
          ro: data.ro_name ? data.ro_name : "-",
          branch: data.branch_name ? data.branch_name : "-",
          name: data.staffName ? data.staffName : "-",
          mobileNo: data.mobileNo ? data.mobileNo : "-",
          email: data.email ? data.email : "-"
        }
      )
    }

  }

  onDisableUserCancel() {
    this.pfNumber = '';
    this.disableUserDetails = null;
  }

  openDisableUserConfirmModal() {
    const dialogData: DialogData = {
      heading: '',
      content1: 'Are you sure you want to disable the user? Cannot enable the user',
      content11: '',
      content2: '',
      button1Text: 'Yes',
      button2Text: 'No',
      showWaiting: false,
      showBuffering: false,
      content3: '',
      content4: '',
      content5: '',
      content6: '',
      content7: '',
      content8: '',
      content9: '',
      content10: '',
    };

    const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
      data: dialogData,
      width: '400px', // Set the desired width of the dialog
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        dialogData.content1 = 'Processing your request';
        dialogData.button1Text = '';
        dialogData.button2Text = '';
        dialogData.showWaiting = true;
        const confirmDialog = this.dialog.open(OpenAdminDialogYesOrNo, {
          data: dialogData,
          width: '400px',
          disableClose: true,
        });

        this.adminservice
          .disableUser(this.disableUserDetails.id, this.pfNumber, this.roleId, this.adminId)
          .subscribe(
            (response) => {
              confirmDialog.close();
              dialogData.button1Text = 'Ok';
              dialogData.button2Text = '';
              dialogData.showWaiting = false;
              if (!response.status) {
                dialogData.content1 = response.message;
              } else {
                dialogData.content1 = 'User disabled successfully';
                this.onDisableUserCancel();
              }
              this.dialog.open(OpenAdminDialogYesOrNo, {
                data: dialogData,
                width: '400px',
                disableClose: true,
              });
            },
            (error) => {
              confirmDialog.close();
              this.snackbar.open(error.message, 'OK', {
                duration: 4000,
              });
            }
          );
      } else if (result === 'no') {
        this.onDisableUserCancel();
      }
    });
  }

  resetPasswordSubmit(data) {
    console.log(data)
    const dialogData: DialogData = {
      heading: '',
      content1: `Are you sure you want to reset password for the staff ID ${data.staffId}?`,
      content11: '',
      content2: '',
      button1Text: 'Yes',
      button2Text: 'No',
      showWaiting: false,
      showBuffering: false,
      content3: '',
      content4: '',
      content5: '',
      content6: '',
      content7: '',
      content8: '',
      content9: '',
      content10: '',
    };

    const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
      data: dialogData,
      width: '400px', // Set the desired width of the dialog
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
      let dataToReset = {
        prd:data.password,staffId:data.staffId
      }
      this.resetPassword(dataToReset);
     
      } else if (result === 'no') {
      this.onResetCancel();
      }
    });
  }


  onResetCancel() {
    this.resetForm.reset();
  }

  fetchSolIdDetails(solId) {

    if (this.viewDetailsSolIdText == constants.HIDE_DETAILS) {
      this.isSolIdReadOnly = false;
      this.showSolIdDetail = false;
      this.viewDetailsSolIdText = constants.VIEW_DETAILS
      return
    }

    this.adminservice.getSolIdDetails(solId).subscribe((resp) => {
      console.log(resp)
      if (resp && resp.status) {
        if (resp && resp.result) {
          let type = resp.result.type;
          if (type) {
            this.solIdType = type;
            let result = resp.result;
            if (type == "Branch") {
              this.showSolIdDetail = true;
              this.viewDetailsSolIdText = constants.HIDE_DETAILS;
              this.isSolIdReadOnly = true;
              this.transferForm.patchValue(
                {
                  state_name: result.state_name ? result.state_name : "-",
                  zone_name: result.zone_name ? result.zone_name : "-",
                  zone_code: result.zone_code ? result.zone_code : "-",
                  ro_name: result.ro_name ? result.ro_name : "-",
                  ro_code: result.ro_code ? result.ro_code : "-",
                  branch_name: result.branch_name ? result.branch_name : "-",
                  branch_code: result.branch_code ? result.branch_code : "-",
                }
              )
            } else if (type == "RO") {
              this.showSolIdDetail = true;
              this.viewDetailsSolIdText = constants.HIDE_DETAILS;
              this.isSolIdReadOnly = true;
              this.transferForm.patchValue(
                {
                  state_name: result.state_name ? result.state_name : "-",
                  zone_name: result.zone_name ? result.zone_name : "-",
                  zone_code: result.zone_code ? result.zone_code : "-",
                  ro_name: result.ro_name ? result.ro_name : "-",
                  ro_code: result.ro_code ? result.ro_code : "-",

                }
              )
            } else if (type == "Zone") {
              this.showSolIdDetail = true;
              this.viewDetailsSolIdText = constants.HIDE_DETAILS;
              this.isSolIdReadOnly = true;
              this.transferForm.patchValue(
                {
                  state_name: result.state_name ? result.state_name : "-",
                  zone_name: result.zone_name ? result.zone_name : "-",
                  zone_code: result.zone_code ? result.zone_code : "-",
                }
              )
            }
          }
        } else {
          this.snackbar.open("No result found for the entered Sol ID", "OK", { duration: 3000 })
        }
      } else if (resp.message == "no records available") {
        this.snackbar.open("No record found for the entered Sol ID", "OK", { duration: 3000 })
      } else {
        this.snackbar.open(resp.message ? resp.message : "Something went wrong", "OK", { duration: 3000 })
      }
    },(err)=>{
      this.snackbar.open("Something went wrong","OK",{duration:3000})
    })
  }

  resetPassword(value) {
    this.loading = true;
    value = {
      prd: value.prd, staffId: value.staffId, type: "forgot"
    }
    console.log('final', value);
    this.adminAuth.setNewPassword(value).subscribe(res => {
      if (res && res.success) {
        this.resetForm.reset()
        console.log('final');
        this.loading = false;
        if (res.message == 'Password Updated Successfully' || res.message == 'Password Deleted and Updated Successfully') {
          const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: {
              content1: constants.PASSWORD_UPDATED_SUCCESSFULLY,
              button1Text: "OK",
            }
          });
          dialogRef.afterClosed().subscribe(res => {
            console.log(res)
            if (res == "dontClose") {
              this.router.navigate(['/login-admin']);
            } else {

            }
          })
        } else
          if (res.message == 'Password Already exist') {
            const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
              width: 'auto', height: 'auto',
              data: {
                content1: constants.PASSWORD_ALREADY_EXISTS,
                button1Text: "OK",
              }
            });
          } else
            if (res.message == 'Password Should atleast be 10 characters length and should contain one special character, one lower case letter, one upper case letter and 1 digit') {
              const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
                width: 'auto', height: 'auto',
                data: {
                  content1: "Password Should atleast be 10 characters length and should contain one special character, one lower case letter, one upper case letter and one number",
                  button1Text: "OK",
                }
              });
            }
      } else {
        this.snackbar.open(res.message ? res.message : "Something went wrong", 'OK', { duration: 3000 })
      }

    }, (err) => {
      this.snackbar.open("Something went wrong", "OK", { duration: 3000 })
    }

    )
  }
}
